module.exports = __webpack_public_path__ + "img/dakota.e81742b6.jpg";